var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCheckFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.5,11.3786797 L7.07926548,9.95794513 C6.69756726,9.57624692 6.0624275,9.57361147 5.6723107,9.96372827 L4.96372827,10.6723107 C4.57036744,11.0656715 4.57102227,11.6923426 4.95794513,12.0792655 L7.79941418,14.9207345 C7.98987577,15.1111961 8.24344071,15.2072765 8.49817971,15.2072748 C8.75782457,15.2085219 9.01053368,15.1107867 9.2039796,14.9173407 L15.574195,8.54712535 C15.9636274,8.15769299 15.9619224,7.5268936 15.5718056,7.13677679 L14.8632232,6.42819437 C14.4698624,6.03483353 13.8416718,6.03700781 13.4528746,6.42580501 L8.5,11.3786797 Z M10.5,0 C16.296,0 21,4.704 21,10.5 C21,16.296 16.296,21 10.5,21 C4.704,21 0,16.296 0,10.5 C0,4.704 4.704,0 10.5,0 Z"
})))));
export default SvgCheckFill;